import React from "react"
import PropTypes from "prop-types"
import ReactPlayer from "react-player/lazy"
import styled from "styled-components"
import { VideoPlay } from "@bw/icons"

const ReactPlayerWrapper = styled.div`
  position: relative;
  aspect-ratio: 16 / 9;
  max-width: 760px;
  box-sizing: border-box;
  background-color: #111;
`
const StyledReactPlayer = styled(ReactPlayer)`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: #111;

  .react-player__preview {
    svg {
      position: relative;
      z-index: 2;
    }
    &:after {
      content: "";
      position: absolute;
      inset: 0;
      background-color: var(--page-color-rgba);
    }
  }
`

const Video = ({ url, controls, poster, muted, loop }) => {
  return (
    <ReactPlayerWrapper>
      <StyledReactPlayer
        url={url}
        light={poster}
        controls={controls}
        playing={!!poster}
        volume={1}
        playIcon={<VideoPlay />}
        muted={muted}
        loop={loop}
        width="100%"
        height="100%"
      />
    </ReactPlayerWrapper>
  )
}

Video.propTypes = {
  controls: PropTypes.bool,
  overlay: PropTypes.element,
  url: PropTypes.string.isRequired,
  poster: PropTypes.string,
  muted: PropTypes.bool,
  loop: PropTypes.bool,
}

Video.defaultProps = {
  controls: true,
  muted: false,
  loop: false,
}

export { Video }
